import { useState, useEffect } from "react";
import { saveCostCenterGroup, fetchCostCenters } from "../Api/CostCenterGroup";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const CostCenterGroup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [costCenters, setCostCenters] = useState([]);
  const [groupData, setGroupData] = useState({
    groupCode: "",
    groupName: "",
    costCenterCode: ""
  });

  // Get user details from localStorage
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  // Fetch cost centers for dropdown
  useEffect(() => {
    const loadCostCenters = async () => {
      try {
        const data = await fetchCostCenters();
        setCostCenters(data);
      } catch (error) {
        toast.error("🦄 Failed to load cost centers");
      }
    };
    loadCostCenters();
  }, []);

  const handleChange = (e) => {
    setGroupData({ ...groupData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCostCenterGroup(groupData, userId);
      toast.success("🦄 Cost Center Group Added Successfully");
      setGroupData({
        groupCode: "",
        groupName: "",
        costCenterCode: ""
      });
      navigate("/viewCostCenterGroup");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand"> 
          <Container fluid className="fields-container">
            <h2 className="fields-title">Cost Center Group</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Group Code <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="groupCode" 
                      value={groupData.groupCode} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Group Name <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="groupName" 
                      value={groupData.groupName} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Cost Center Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="costCenterCode" 
                      value={groupData.costCenterCode} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Cost Center</option>
                      {costCenters.map((center) => (
                        <option key={center.code} value={center.code}>
                          {center.code} - {center.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Group
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {/* Loader Overlay */}
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default CostCenterGroup;